// extracted by css-extract-rspack-plugin
export default {"draftBanner":"DraftBanner-module__draftBanner","draftBannerContent":"DraftBanner-module__draftBannerContent","draftBannerText":"DraftBanner-module__draftBannerText"};